const selectors = {
  //pagesREgisterForm
  productRegister: "[data-register-product-form]",
  formMessage: "[data-form-message]",
  radioFormMessage: "[data-form-message-blue]",
  dataCheckbox: "[data-form-checkbox]",
  formProduct: "[data-form-product]",
  productRegisterSub: "[data-register-product-button]",
  dataFormMessage: "[data-successful-box]",
  landingGift: "[data-landing-gift]",
};
const productForm = document.querySelector(selectors.productRegister);
const productRegisterSub = document.querySelector(selectors.productRegisterSub);
const dataFormMessage = document.querySelector(selectors.dataFormMessage);

disableItems();

function disableItems() {
  const dataCheckbox = document.querySelectorAll(selectors.dataCheckbox);
  const formProduct = document.querySelectorAll(selectors.formProduct);
  const radioFormMessage = document.querySelector(selectors.radioFormMessage);

  var checkItemsCount = 0;

  formProduct.forEach((product, index) => {
    product.addEventListener("click", function () {
      if (product.classList.contains("active")) {
        dataCheckbox[index].checked = false;
        checkItemsCount = checkItemsCount - 1;
        formProduct[index].classList.remove("active");
      } else {
        dataCheckbox[index].checked = true;
        checkItemsCount = checkItemsCount + 1;
        formProduct[index].classList.add("active");
      }
      formCheckCount();
    });
  });

  function formCheckCount() {
    formProduct.forEach((product) => {
      const uncheckProduct = product.classList.contains("active") === false;
      //mostrar mensaje de lso 5 productos
      if (checkItemsCount === 5) {
        radioFormMessage.classList.remove("hide");
      } else {
        radioFormMessage.classList.add("hide");
      }
      //validar estado de los checkbox
      if (checkItemsCount === 5 && uncheckProduct === true) {
        product.classList.add("disable");
      } else {
        product.classList.remove("disable");
      }
    });
  }
}

//Envio de formulario
productForm.addEventListener("submit", function (event) {
  event.preventDefault();
  formValidation();
  function checkFormInputs(arrayInput) {
    var inputArray = [];
    for (var i = 0; i < arrayInput.length; i++) {
      if (arrayInput[i].checked) {
        inputArray.push(arrayInput[i].value);
      }
    }
    return inputArray;
  }

  function formValidation() {
    const inputOne = productForm.name;
    const inputTwo = productForm.email;
    const inputThree = productForm.querySelectorAll("input[name='products[]']");
    const inputThreeArray = checkFormInputs(inputThree);
    const formMessage = document.querySelector(selectors.formMessage);
    const landingGift = document.querySelector(selectors.landingGift);

    if (inputOne.value === "" || inputTwo.value === "") {
      formMessage.innerHTML = "Faltan campos por llenar";
    } else if (inputThreeArray.length < 5) {
      formMessage.innerHTML = "*¡Debes seleccionar 5 productos!";
    } else {
      productRegisterSub.innerHTML = "Enviando...";
      productRegisterSub.disabled = true;
      const sendData = new FormData(productForm);

      const config = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
        },
        body: sendData,
      };
      config.headers["X-Requested-With"] = "XMLHttpRequest";

      fetch("https://merken.custom.cl/landing-qr", config)
        .then((response) => response.json())
        .then((response) => {
          if (response.email) {
            formMessage.innerHTML =
              "Este correo electrónico ya está participando";
            formMessage.classList.remove("hide");
            productRegisterSub.innerHTML = "Enviar";
            productRegisterSub.disabled = false;
          } else {
            dataFormMessage.classList.remove("hide");
            productForm.classList.add("hide");
            productRegisterSub.innerHTML = "Enviar";
            const messageBoxOffset =
              dataFormMessage.offsetTop - (header.offsetHeight + 30);
            window.scroll({
              top: messageBoxOffset,
              left: 0,
              behavior: "smooth",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
});
